import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SetupSmartMeterComponent } from './setup-smart-meter.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [SetupSmartMeterComponent],
  imports: [CommonModule, RouterModule],
  exports: [SetupSmartMeterComponent],
})
export class SetupSmartMeterModule {}
